import {Col, Row, Typography} from "antd";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import WinFormInput from "./WinFormInput";
import {useEffect} from "react";
import ResultText from "../ResultText";

export default function DeckRoadwayEditor({data, windowName, targetWindow, title}) {
    const getTableData = () => {
        const table_us = data?.station_table_us
        const table_ds = data?.station_table_ds
        const diff = table_us?.length > table_ds?.length;
        if(diff > 0) {
            for (let i=0; i<diff; i++) {
                table_us?.push([])
            }
        }
        else {
            for (let i=0; i<Math.abs(diff); i++) {
                table_ds?.push([])
            }
        }

        for(let i=0; i<table_us.length; i++) {
            const ds = table_ds[i] || []
            table_us[i] = [...table_us[i], ...ds]
        }

        return table_us
    }

    const setStyleForInput = (name) => {
        if(!targetWindow)
            return

        const id = `${targetWindow}-${name}`
        const elementBase = document.getElementById(id)
        const elementCmp = document.getElementById(`${windowName}-${name}`)

        if(elementBase && elementCmp) {
            if(elementBase.innerText !== elementCmp.innerText)
                elementCmp.style.color = 'red'
        }
    }

    const setStyleForRadio = (name) => {
        if(!targetWindow)
            return

        const base_radio_id = `${targetWindow}-${name}-radio`
        const cmp_radio_id = `${windowName}-${name}-radio`
        const baseVal = document.querySelector(`input[name=${base_radio_id}]:checked`)?.value
        const cmpVal = document.querySelector(`input[name=${cmp_radio_id}]:checked`)?.value

        if(baseVal !== cmpVal) {
            const element = document.getElementById(`${windowName}-${name}`);
            if(element)
                element.style.color = 'red'
        }
    }

    const setStyleForTable = (name, skipIndex=[]) => {
        if(!targetWindow)
            return

        const base_tbody = document.getElementById(`${targetWindow}-${name}`)
        const cmp_tbody = document.getElementById(`${windowName}-${name}`)

        if(base_tbody && cmp_tbody) {
            for(let i=0; i<cmp_tbody.rows.length; i++) {
                const row = cmp_tbody.rows[i]
                for(let m=0; m<row.cells.length; m++) {
                    if(skipIndex.findIndex(x => x === m) >= 0)
                        continue

                    const cell = row.cells[m]
                    if(cell.innerText !== base_tbody.rows[i]?.cells[m]?.innerText)
                        cell.style.color = 'red'
                }
            }
        }
    }

    useEffect(() => {
        setStyleForInput('distance')
        setStyleForInput('width')
        setStyleForInput('weir_coef')
        setStyleForInput('us_embankment_ss')
        setStyleForInput('ds_embankment_ss')
        setStyleForInput('max_submergence')
        setStyleForInput('min_weir_flow_el')
        setStyleForRadio('weir_crest_shape')
        setStyleForTable('station_table', [0])
    }, [])

    return (
        <div>
            <Typography.Text style={{fontSize: '11pt', fontWeight: 'bold'}}>
                {title} Plan
            </Typography.Text>
            <div style={{width: 480, backgroundColor: '#f5f5f5', fontSize: '9pt', padding: 2, paddingLeft: 4, paddingRight: 4}} id={windowName}>
                <table style={{width: '100%'}}>
                    <tr>
                        <td>
                            <div style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Distance</div>
                        </td>
                        <td>
                            <div style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Width</div>
                        </td>
                        <td>
                            <div style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Weir Coef</div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{width: '33.3%'}}>
                            <WinFormInput id={`${windowName}-distance`} style={{width: '100%'}}>
                                {data?.distance}
                            </WinFormInput>
                        </td>
                        <td style={{width: '33.3%'}}>
                            <WinFormInput id={`${windowName}-width`} style={{width: '100%'}}>
                                {data?.width}
                            </WinFormInput>
                        </td>
                        <td style={{width: '33.3%'}}>
                            <WinFormInput id={`${windowName}-weir_coef`} style={{width: '100%'}}>
                                {data?.weir_coef}
                            </WinFormInput>
                        </td>
                    </tr>
                </table>
                <table style={{width: '100%', marginTop: 8}}>
                    <thead style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                        <tr style={{backgroundColor: '#008080', color: 'white',  textAlign: 'center'}}>
                            <td colSpan={4}>Upstream</td>
                            <td colSpan={3}>Downstream</td>
                        </tr>
                        <tr>
                            <ResultHeaderCell style={{width: 30}}></ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>High Chord</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Low Chord</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>High Chord</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Low Chord</ResultHeaderCell>
                        </tr>
                    </thead>
                    <div style={{overflow: 'auto'}}>
                        <tbody id={`${windowName}-station_table`} style={{height: 250, tableLayout: 'fixed', width: '100%', display: 'block'}}>
                        {
                            getTableData().map((x,idx) => (
                                <tr>
                                    <ResultHeaderCell style={{width: 30}}>{idx+1}</ResultHeaderCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[0]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[1]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[2]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[3]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[4]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[5]}</ResultBodyCell>
                                </tr>
                            ))
                        }
                        </tbody>
                    </div>
                </table>
                <div style={{display: 'flex', alignItems: 'center', marginTop: 8, width: '100%', justifyContent: 'space-between'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <label style={{width: 120}}>U.S Embankment SS</label>
                        <WinFormInput id={`${windowName}-us_embankment_ss`}>
                            {data?.us_embankment_ss}
                        </WinFormInput>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <label style={{width: 120}}>D.S Embankment SS</label>
                        <WinFormInput id={`${windowName}-ds_embankment_ss`}>
                            {data?.ds_embankment_ss}
                        </WinFormInput>
                    </div>
                </div>
                <fieldset style={{border: '1px solid #a5a5a5', padding: 4, marginTop: 8}}>
                    <legend style={{fontSize: '9pt', marginLeft: 4, paddingLeft: 2, width: 60}}>Weir Data</legend>
                    <div style={{display: 'flex', alignItems: 'center', marginTop: 8, width: '100%', justifyContent: 'space-between'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <label style={{width: 120}}>Max Submergence</label>
                            <WinFormInput id={`${windowName}-max_submergence`}>
                                {data?.max_submergence}
                            </WinFormInput>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <label style={{width: 120}}>Min Weir Flow El:</label>
                            <WinFormInput id={`${windowName}-min_weir_flow_el`}>
                                {data?.min_weir_flow_el}
                            </WinFormInput>
                        </div>
                    </div>
                    <div style={{marginTop: 8}}>
                        <div id={`${windowName}-weir_crest_shape`} style={{textDecoration: 'underline'}}>Weir Crest Shape</div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input name={`${windowName}-weir_crest_shape-radio`} type={'radio'} readOnly={true} value={'broad_crested'} checked={data?.weir_crest_shape === 0}/>
                            <label style={{marginLeft: 2}}>Broad Crested</label>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input name={`${windowName}-weir_crest_shape-radio`} type={'radio'} readOnly={true} value={'ogee'} checked={data?.weir_crest_shape === -1}/>
                            <label style={{marginLeft: 2}}>Ogee</label>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    )
}